import React from 'react';
import GreySeparator from './GreySeparator.jsx';

export default function FootNotes({notes, separator}) {
    return (
        <div className="checkout-footnotes-section">
            {separator && <GreySeparator />}
            {notes
                .filter(note => { return note?.trim().length > 0 })
                .map((note, index) => {
                    return <p className="checkout-footnotes-section__footnote" dangerouslySetInnerHTML={{__html: note}} key={index}/>;
                })
            }
        </div>
    );
}
